const { getElement } = window.BAO.Utils

class MarketSwitcherSelect extends window.BAO.CustomElement({
  SuperClass: HTMLSelectElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleChange = this.handleChange.bind(this)

    this.listeners.add(this, 'change', this.handleChange)
  }

  handleChange (event) {
    const selectedOption = event.target.options[event.target.selectedIndex]
    const selectedImage = selectedOption?.getAttribute('data-flag')
    const img = this.image

    if (selectedImage && img) {
      img.src = selectedImage
      img.srcset = ''
    }
  }

  get image () {
    return getElement('img', { context: this.externalEls.image.element })
  }
}

if (!customElements.get('market-switcher-select')) {
  customElements.define('market-switcher-select', MarketSwitcherSelect, {
    extends: 'select',
  })
}
